// Pausa do Pomodoro ("Break time" do Blitzit): contagem azul, pular pausa e
// "Voltar ao foco" quando a pausa acaba (P0.5). Antes dela, a hora de relaxar: o tomate
// relaxando com "Vamos relaxar" (o descanso só começa com o clique) e "Pular descanso".
import { useTranslation } from 'react-i18next';
import { pomodoroView } from '../domain/pomodoro';
import { formatDuration } from '../i18n/format';
import { useAppState } from '../state/AppStore';
import { usePomodoro } from '../state/usePomodoro';
import { useNow } from '../state/useNow';
import { Icon } from './Icon';
import { Tomato } from './Tomato';

/** Hora de relaxar (AC-062 / AC-069): fica esperando o clique em "Vamos relaxar". */
export function RelaxScreen({ canEdit }: { canEdit: boolean }) {
  const { t } = useTranslation();
  const { state, controller } = usePomodoro();
  return (
    <section className="break relax" data-testid="relax-screen" aria-label={t('pomodoro.relaxTitle')}>
      <Tomato size={88} relaxed />
      <p className="break__title">{t('pomodoro.relaxTitle')}</p>
      <p className="break__task">{t('pomodoro.relaxBody', { duration: formatDuration(state.breakSec, t) })}</p>
      <div className="break__actions">
        <button type="button" className="btn btn--ghost" disabled={!canEdit} onClick={() => void controller.resume()}>
          <Icon name="skip" size={14} />
          {t('pomodoro.skipRest')}
        </button>
        <button type="button" className="btn btn--primary" onClick={() => controller.relax()}>
          {t('pomodoro.relaxNow')}
        </button>
      </div>
    </section>
  );
}

export function BreakScreen({ canEdit }: { canEdit: boolean }) {
  const { t } = useTranslation();
  const now = useNow();
  const { state, controller } = usePomodoro();
  const task = useAppState((s) => s.tasks.find((x) => x.id === state.taskId) ?? null);
  if (state.phase !== 'break' && state.phase !== 'breakOver') return null;
  const view = pomodoroView(state, now);
  const over = state.phase === 'breakOver';

  return (
    <section className="break" data-testid="break-screen" aria-label={t('pomodoro.breakLabel')}>
      <div className="break__icon">
        <Icon name="coffee" size={22} />
      </div>
      <p className="break__title">{over ? t('pomodoro.backToFocusTitle') : t('pomodoro.breakTitle')}</p>
      {!over && (
        <p className="break__timer" role="timer">
          {view.text}
        </p>
      )}
      {task && <p className="break__task">{t('pomodoro.breakTask', { title: task.title })}</p>}
      <div className="break__actions">
        {!over && (
          <button type="button" className="btn btn--ghost" onClick={() => controller.skipBreak()}>
            <Icon name="skip" size={14} />
            {t('pomodoro.skipBreak')}
          </button>
        )}
        <button type="button" className="btn btn--primary" disabled={!canEdit} onClick={() => void controller.resume()}>
          <Icon name="play" size={12} filled />
          {t('pomodoro.resume')}
        </button>
      </div>
    </section>
  );
}
